import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import cx from 'classnames';

interface props {
  text: string;
  url?: string;
  css?: string;
  iconCss?: string;
}

const MoreLink: React.FC<props> = (props) => {
  return (
    <a href={props.url ? props.url : '#'} className={cx('flex_1', props.css)}>
      <span> {props.text}</span>
      <RightOutlined
        className={props.iconCss}
        style={{ margin: '1px  0 0 4px' }}
      />
    </a>
  );
};

export default MoreLink;
